module.exports = __webpack_public_path__ + "assets/flash-card-demo-277c8cc9fbe18ed89ae287abafcc6976.mp4";